import {
    AppstoreOutlined,
    BellOutlined,
    DashboardOutlined,
    ExclamationCircleOutlined,
    FileOutlined,
    FileTextOutlined,
    HomeOutlined,
    LineChartOutlined,
    UserOutlined,
    WifiOutlined,
} from '@ant-design/icons';
import React from 'react';

const CATEGORY_ICONS = {
    Користувачі: UserOutlined,
    "Об'єкти": HomeOutlined,
    Звіти: FileTextOutlined,
    Модеми: WifiOutlined,
    Лічильники: DashboardOutlined,
    Файли: FileOutlined,
    Модулі: AppstoreOutlined,
    Моніторинг: LineChartOutlined,
    Аномалії: ExclamationCircleOutlined,
    Помилки: ExclamationCircleOutlined,
};

const NotificationCategoryIcon = ({category}) => {
    const Icon = CATEGORY_ICONS[category] || BellOutlined;

    return <Icon aria-hidden />;
};

export default NotificationCategoryIcon;
